import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { JournalHighlightsSection, JournalHighlightsSlider } from '../../../common/components/JournalHighlights';
import { selectJournalHighlights } from '../../../common/selectors/journal';
import { trackJournalHighlightsClick, trackJournalHighlightsView } from '../../../common/tracking';

export function JournalHighlightsContainer() {
  const journalHighlights = useSelector(selectJournalHighlights);

  const handleLinkClick = React.useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    const href = e.currentTarget.href;
    trackJournalHighlightsClick(href);
  }, []);

  if (!journalHighlights || journalHighlights.length === 0) {
    return null;
  }

  return (
    <ActionAfterViewed callback={trackJournalHighlightsView}>
      <JournalHighlightsSection>
        <JournalHighlightsSlider items={journalHighlights} onLinkClick={handleLinkClick} />
      </JournalHighlightsSection>
    </ActionAfterViewed>
  );
}
